import {createElement, forwardRef} from 'react';

//Credit - https://github.com/tamagui/tamagui/blob/master/packages/web/src/helpers/withStaticProperties.tsx

const Decorated = Symbol();

export const withStaticProperties = function <A extends Function, B>(
  component: A,
  staticProps: B
): A & B {
  // clone component if already wrapped once
  const next = (() => {
    if (component[Decorated]) {
      const _ = forwardRef((props, ref) =>
        createElement(component as never, {...props, ref})
      );
      // attach existing things again
      for (const key in component) {
        const v = component[key];
        // @ts-ignore
        _[key] = v && typeof v === 'object' ? {...v} : v;
      }
    }
    return component;
  })();

  // add new things
  Object.assign(next, staticProps);
  next[Decorated] = true;

  return next as never as A & B;
};